<template>
    <div id="csContainer">
        <el-button class="getModel" size="small" type="primary" @click="getModel()" >高亮模型</el-button>
    </div>
</template>

<script>
/* eslint-disable */
import * as Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import util from "../../components/util"
// import viewTool from "../camera/viewTool"
export default {
    name: "schoolModel",

    data () {
      return {
          viewer: null,
          model:null,
      }
    },
    mounted() {
        this.init();
    },
    methods: {
      init() {
        this.viewer = util.getViewer("csContainer");
        let viewer = this.viewer;
        let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(116.298782,40.047983, 0.0));

        var ab = Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 70.0)
          let mz = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(115));
          modelMatrix = Cesium.Matrix4.multiplyByMatrix3(modelMatrix, mz, new Cesium.Matrix4());
          let m = Cesium.Matrix4.fromArray([
              1.0, 0.0, 0.0, 0.0,
              0.0, 1.0, 0.0, 0.0,
              0.0, 0.0, 1.0, 0.0,
              -70, 25, 0.0, 1.0
          ]);
          modelMatrix =  Cesium.Matrix4.multiply(modelMatrix, m, m);

        this.model = viewer.scene.primitives.add(Cesium.Model.fromGltf({
          name: 'car',
          // url : "/demo/static/data/models/car.glb",
          url : "/demo/static/data/models/bank.glb",
          // url : 'http://localhost:5000/shanhuasi.gltf',
          modelMatrix : modelMatrix,
            // scale : 0.00025,
            scale : 0.3,
            // scale : 30,
           clampToGround: true,
        }));
        // viewer.camera.setView({
        //   destination : Cesium.Cartesian3.fromDegrees(116.298782,40.047983, 70.0),
        //   orientation : {
        //     heading : Cesium.Math.toRadians(-35),
        //     pitch : Cesium.Math.toRadians(-95),
        //     roll : 0.0
        //   }
        // });
          let  cf = new Cesium.Cartesian3(-2166257.8851362765, 4383232.458673301, 4082063.179322425)  ;

          this.viewer.camera.setView({
              destination :cf,
              orientation : {
                  heading : 3.744204967711287,
                  pitch : -0.35593585652530746,
                  roll : 6.28118791231724
              }
          });
      },
        getModel(){
            let viewer = this.viewer;
            let model = this.model;
            let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
            handler.setInputAction(function (movement) {
                var pickedObject = viewer.scene.pick(movement.endPosition);
                if(Cesium.defined(pickedObject)&&(pickedObject.id === model.id)){
                    // entity.model.scale = 1.5;
                    model.color =  Cesium.Color.BLUE;
                    model.colorBlendMode = Cesium.ColorBlendMode['MIX'];
                }else{
                    model.color =  Cesium.Color.WHITE;
                    // model.colorBlendMode = Cesium.ColorBlendMode['MIX'];
                    model.colorBlendMode = Cesium.ColorBlendMode['HIGHLIGHT'];
                }
            },Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        }
    },
  }
</script>

<style scoped>
    .getModel {
        position: absolute;
        margin-left: 25px;
        margin-top:7px;
        z-index: 999;
    }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
